import { MultiCollapsible } from "@bonliva-crm/ui";
import {
  ProfessionFilterModalInnerProps,
  encodeValue,
  toDecodedLabelValue,
  getProfessionToValue,
  renderSelectType,
  Option
} from "../../utils";
import { ComponentProps, useMemo, useState } from "react";
import { useGlobalStore } from "@hooks";
import locale from "@bonliva-crm/locale";
import { SelectType } from "@bonliva-crm/shared";
import { ExperienceAndJobofferFilter } from "./common/experience-and-joboffer-filter";
import {
  baseOnChange,
  commonCollapsibleProps,
  isCollapsed,
  filterOption,
  isGroupSelected,
  isOptionStandAlone,
  onCollapse
} from "./utils";
import { isFilterSelected } from "../../../../utils/is-filter-selected";
import { sortBy } from "lodash";

export const ExpOnlyFilter = (props: ProfessionFilterModalInnerProps) => {
  const store = useGlobalStore();
  const [collapsedGroups, setCollapsedGroups] = useState<string[]>([]);

  const professionKey = getProfessionToValue(props?.value?.professions?.[0]);

  const professionObject = useMemo(() => {
    return props?.value?.[professionKey];
  }, [props?.value]);

  if (!("specializations" in professionObject)) {
    return null;
  }

  const value = professionObject.specializations.value;
  const type = professionObject.specializations.type;
  const professions = props?.value?.professions;

  const areaOfExpertise = store.cache.getAreaOfExpOnProfessions(professions);

  const options: Option[] = [];

  const isSingleAOE = areaOfExpertise.length === 1;

  areaOfExpertise.forEach((aoe) => {
    const specializationsToOptions = [
      ...new Map(
        aoe.Specializations.map((spec) => ({
          label: spec,
          value: encodeValue(aoe.Name, spec)
        })).map((item) => [item["label"], item])
      ).values()
    ];

    if (!isSingleAOE || specializationsToOptions.length === 0) {
      options.push({
        label: aoe.Name,
        value: aoe.Name
      });
    }

    sortBy(specializationsToOptions, "label").forEach((spec) => options.push(spec));
  });

  const onChange = baseOnChange(
    options,
    (finalValues) => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          specializations: {
            value: finalValues.map((x) => x.value),
            type: type
          }
        },
        interested: finalValues.length > 0 ? props?.value?.interested : "null",
        experienced: finalValues.length > 0 ? props?.value?.experienced : "null"
      });
    },
    isSingleAOE
  );

  const multiSelectProps: ComponentProps<typeof MultiCollapsible<Option>> = {
    ...commonCollapsibleProps,
    placeholder: null,
    inputLabel: locale.Specialization,
    options: options,
    value: toDecodedLabelValue(value),
    onChange: onChange as any,
    isOptionSelected: isGroupSelected(value, options, true),
    isIndeterminate: isGroupSelected(value, options, false),
    filterOption: filterOption(collapsedGroups, isSingleAOE, options),
    isCollapsed: isCollapsed(collapsedGroups),
    isOptionStandAlone: isOptionStandAlone(options),
    onCollapse: onCollapse(collapsedGroups, setCollapsedGroups),
    showBadge: false,
    isClearable: isFilterSelected(professionObject.specializations),
    onClear: () => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          specializations: {
            type: SelectType.ANY,
            value: []
          }
        },
        experienced: null,
        interested: null
      });
    },
    menuChildren: {
      prependedChildren: renderSelectType(type, (t: any) => {
        props.onChange({
          ...props?.value,
          [professionKey]: {
            specializations: {
              value: value,
              type: t
            }
          }
        });
      })
    }
  };

  return (
    <>
      <MultiCollapsible<Option> {...multiSelectProps} />
      {value.length > 0 && <ExperienceAndJobofferFilter {...props} />}
    </>
  );
};
